<template>
    <div class="panel_container">
        <img src="@/assets/themeThree/appInstallBg.png" alt="">
        <van-row class="btn_section">
            <van-col span="24">
                <div class="downloadTitle">{{ $t('home.downloadTitle') }}</div>
            </van-col>
            <van-col span="24">
                <div class="downloadText">{{ $t('home.downloadText') }}</div>
            </van-col>
            <van-col span="24" class="btnGroup">
                <div v-if="iosData.display" class="download_item" :style="{ background: customStyle.color }">
                    <van-row @click="goToLink(iosData.redirect_url)">
                        <van-col span="10" class="btnIcon"><img :src="iosData.url" alt=""></van-col>
                        <van-col span="14" class="textSet">
                            <div class="applicationText">{{ $t('home.application') }}</div>
                            <div class="download_btn" >{{
                                iosData.text }}</div>
                        </van-col>
                    </van-row>
                </div>
                <div v-if="androidData.display" span="11" class="download_item" :style="{ background: customStyle.color }">
                    <van-row @click="goToLink(androidData.redirect_url)">
                        <van-col span="10" class="btnIcon"> <img :src="androidData.url" alt=""></van-col>
                        <van-col span="14" class="textSet">
                            <div class="applicationText">{{ $t('home.application') }}</div>
                            <div class="download_btn"
                                @click="goToLink(androidData.redirect_url)">{{ androidData.text }}</div>
                        </van-col>
                    </van-row>


                </div>
            </van-col>

        </van-row>
    </div>
</template>

<script setup lang="ts">
import { goToLink } from '@/view/home/supportScript';
import { onMounted, ref } from 'vue'

const iosData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const androidData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const customStyle = ref({
    color: ""
})
const props = defineProps<{
    itemData: {
        ios: {
            url: string,
            redirect_url: string,
            display: boolean,
            text: string,
        },
        android: {
            url: string,
            redirect_url: string,
            display: boolean,
            text: string,
        },
        styles: {
            color: string
        }
    }
}>()

onMounted(() => {
    iosData.value.url = props.itemData.ios.url
    iosData.value.display = props.itemData.ios.display
    iosData.value.redirect_url = props.itemData.ios.redirect_url
    iosData.value.text = props.itemData.ios.text

    androidData.value.url = props.itemData.android.url
    androidData.value.display = props.itemData.android.display
    androidData.value.redirect_url = props.itemData.android.redirect_url
    androidData.value.text = props.itemData.android.text

    customStyle.value.color = props.itemData.styles.color
})

</script>
<style scoped>
.panel_container {
    position: relative;
}

.panel_container img {
    width: 100%;
}

.bottom_icon img {
    position: absolute;
    right: 15px;
    top: 0;
    width: 28vw;
}

.btnGroup {
    display: flex;
}

.download_item {
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 10px;
    margin: 5px;
}

.btnIcon {
    display: flex;
    justify-content: right;
}

.btnIcon img {
    width: 50%;
}
.textSet{
    padding: 5px;
}
.download_btn {
    font-size: 12px;
    /* margin-top: 5px; */
    color: #4075d3;
    font-weight: bold;
}
.applicationText{
    font-size: 10px;
    color: #000;
}
@media (min-width: 450px) {
    .bottom_icon img {
        width: 150px;
    }
}

.btn_section {
    position: absolute;
    top: 20%;
    left: 10px;
    right: 10px;
}

.downloadTitle {
    background: linear-gradient(0deg, #bff1ff, #bff1ff), linear-gradient(180deg, #fff, rgba(255, 255, 255, 0));
    background-clip: border-box, border-box;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-size: 26px;
    font-weight: 800;
    box-shadow: 0 .13rem .26rem rgba(0, 0, 0, .14);
}

.downloadText {
    --tw-text-opacity: 1;
    color: rgb(137 159 190 / var(--tw-text-opacity, 1));
    font-size: 15px;
    font-weight: 600;
    padding: 25px 0;
    line-height: 25px;
}

.transfer_btn {
    color: #fff;
    font-weight: bold;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.transfer_btn img {
    width: 25px;
    padding-right: 10px;
}

.logo img {
    width: 110px;
}

.logo {
    display: flex;
    align-items: center;
    justify-content: center;
}

.bottom_section {
    position: relative;
    margin-top: -65px;
}

@media (max-width:400px) {
    .bottom_section {
        margin-top: -45px;
    }
}
</style>